import { render, staticRenderFns } from "./ExportPrestataires.vue?vue&type=template&id=35a6a172"
import script from "./ExportPrestataires.vue?vue&type=script&lang=js"
export * from "./ExportPrestataires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports